import { Link } from "react-router-dom";

const COLS = [
  {
    title: "The Group",
    links: [
      { to: "/our-story", label: "Our Story" },
      { to: "/leadership", label: "Leadership" },
      { to: "/media", label: "Media & Updates" },
      { to: "/contact?type=partnership", label: "Business Partnerships" },
      { to: "/contact?type=careers", label: "Careers" },
    ],
  },
  {
    title: "Jewellery",
    links: [
      { to: "/jewellery", label: "Overview" },
      { to: "/jewellery/wholesale", label: "Wholesale" },
      { to: "/jewellery/retail", label: "Retail & Appointments" },
      { to: "/jewellery/rates", label: "Live Gold Rate" },
      { to: "/jewellery/catalogue", label: "Request Catalogue" },
    ],
  },
  {
    title: "Real Estate",
    links: [
      { to: "/real-estate", label: "RK Builders" },
      { to: "/projects", label: "Our Developments" },
      { to: "/site-visit", label: "Book a Site Visit" },
      { to: "/landowner-partnerships", label: "Landowner Partnerships" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/legal/privacy-policy", label: "Privacy Policy" },
      { to: "/legal/terms-of-use", label: "Terms of Use" },
      { to: "/legal/cookie-policy", label: "Cookie Policy" },
      { to: "/legal/disclaimers", label: "Disclaimers" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#05080E] border-t border-white/[0.06]">
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-10">
          <div className="md:col-span-4 md:pr-12">
            <Link to="/" data-testid="footer-logo" className="inline-block">
              <img src="/images/rk-logo.png" alt="RK Group — Home" className="h-14 w-[59px] shrink-0 object-contain" />
            </Link>
            <p className="text-sm text-[#94A3B8]/80 leading-loose mt-10 max-w-sm">
              Ramesh Kapoor &amp; Sons Jewellers Pvt. Ltd. and RK Builders, united under one family-led group.
              Jewellery across manufacturing, wholesale and retail, alongside thoughtfully planned residential
              developments.
            </p>
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#C5A059]/90 mt-10 font-medium">
              Founder &amp; Chairman — Ramesh Chand Kapoor
            </p>
          </div>
          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <p className="text-[10px] uppercase tracking-[0.28em] text-[#FBF9F5]/40 font-medium mb-8">
                {col.title}
              </p>
              <ul className="space-y-4">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="inline-block text-[13px] text-[#FBF9F5]/55 hover:text-[#C5A059] transition-colors duration-300 py-0.5"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-20 pt-10 border-t border-white/[0.05] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <p className="text-xs text-[#94A3B8]/60 tracking-wide" data-testid="footer-copyright">
            © 2026 RK Group. All rights reserved.
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="text-[10px] uppercase tracking-[0.24em] text-[#94A3B8]/50 hover:text-[#C5A059] transition-colors duration-300"
          >
            Administration
          </Link>
        </div>
      </div>
    </footer>
  );
}
